import { LinearProgress } from '@packages/shared/src/ui/LinearProgress/LinearProgress';
import { FormattedMessage } from 'react-intl';
import { maximumSamples } from '../../SampleOrderSteps/schema';

export type CounterProps = {
  currentCount: number;
};

export const Counter = ({ currentCount }: CounterProps) => (
  <div>
    <LinearProgress mode="determinateWithoutValue" value={(currentCount * 100) / maximumSamples} />
    <div className="text-size-body3 text-color-text-darktransparent px-2 py-0.5 text-right">
      {currentCount}/{maximumSamples}{' '}
      <FormattedMessage defaultMessage={'Muster'} id="sampleOrder.counter.label" />
    </div>
  </div>
);
